module.exports = __webpack_public_path__ + "static/media/Bandar Al Qubisy.704ee997.jpg";